import { Clickable, Col, H3, H4, P, Row, Section, Wrapper } from '@ahmdigital/ui';

import Banner from '../../elements/banner';
import constants from '../../ahm-constants';
import Head from '../../../utils/head';
import LegacyBorderedWrapper from '../../components/legacy-bordered-wrapper';
import Phone from '../../elements/phone';
import textStyles from '../../application/common/text.module.sass';

const SecurityPolicyPage = () => (
  <LegacyBorderedWrapper>
    <div className={textStyles.text}>
      <Head>
        <title>ahm Security Policy</title>
        <meta
          name="description"
          content="Keeping your information safe and secure is our biggest priority. Read about how we protect your information."
        />
      </Head>
      <Banner title="Security" />
      <Section>
        <Wrapper>
          <Row>
            <Col sm={12} df={9}>
              <H3>Email address and password</H3>
              <P>
                Access to your account is controlled using your email address and password. Please make sure that you
                keep your email address and password secure, as any action performed in your account using your email
                address will be treated as yours.
              </P>
              <P>
                If you think someone else may know your password, you can reset your password by heading to{' '}
                <Clickable to={constants.URLS.MEMBERS.HOME}>members.ahm.com.au</Clickable> and clicking on forgot
                password.
              </P>
            </Col>
          </Row>
        </Wrapper>
      </Section>
      <Section>
        <Wrapper>
          <Row>
            <Col sm={12} df={9}>
              <H3>Updating your details</H3>
              <P>
                If you need to update your account information, you can{' '}
                <Clickable to={constants.URLS.MEMBERS.HOME}>log in</Clickable> or call us on <Phone />.
              </P>
              <H4>We will NEVER:</H4>
              <ul>
                <li>call or email you asking you for your password.</li>
                <li>
                  send you an email asking you to verify your online member details. Any email asking you to verify or
                  confirm your account details or using a similar form of words, is most likely a phishing scam.
                </li>
              </ul>
              <P>
                We take online fraud very seriously. If you think you may have revealed your security details in any way
                please contact us immediately on <Phone />.
              </P>
            </Col>
          </Row>
        </Wrapper>
      </Section>
      <Section>
        <Wrapper>
          <Row>
            <Col sm={12} df={9}>
              <H3>What is ‘Phishing’?</H3>
              <P>
                Phishing is the act of attempting to gain information such as usernames, passwords, and other personal
                or sensitive information by acting as a trustworthy organisation via electronic communication. Phishing
                often directs users to enter details on a fake website which looks and feels almost identical to the
                legitimate one.
              </P>
              <P>
                If you think you may have received a phishing email, please forward the entire email with full header
                information (some email clients allow this with an option of sending as an attachment) to{' '}
                <Clickable to="mailto:scamreport@medibank.com.au">scamreport@medibank.com.au</Clickable>.
              </P>
            </Col>
          </Row>
        </Wrapper>
      </Section>
      <Section>
        <Wrapper>
          <Row>
            <Col sm={12} df={9}>
              <H3>Security tips</H3>
              <P>You can help make your online experience more secure by following some basic steps:</P>
              <ul>
                <li>
                  Make sure you are using the most recent version of your web browser with the latest security patches
                  applied.
                </li>
                <li>Install all security updates for your operating system supplied by its maker.</li>
                <li>Ensure that you have up-to-date anti-virus software installed and working on your computer.</li>
                <li>Make sure that you log out properly and close the browser window when you have finished.</li>
                <li>
                  For more simple steps to protect your personal details, visit the Australian government website{' '}
                  <Clickable to={constants.URLS.THIRD_PARTY.STAYSMARTONLINE} inNewTab>
                    Stay Safe Online
                  </Clickable>
                </li>
              </ul>
            </Col>
          </Row>
        </Wrapper>
      </Section>
    </div>
  </LegacyBorderedWrapper>
);

export default SecurityPolicyPage;
